import { APIClient } from "../api";
import { FastSolicitation, ReopenSolicitation, EndSolicitation, FastSolicitationAttendant } from "../../models/FastSolicitation";

export default class FastSolicitationService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async newSolicitation(solicitation: FastSolicitation) {
        const solicitation_ = JSON.stringify(solicitation);
        const url = this.endpoint + `/FastSolicitation/New`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: solicitation_
        });
    }

    async newSolicitationAttendant(solicitation: FastSolicitationAttendant) {
        const solicitation_ = JSON.stringify(solicitation);
        const url = this.endpoint + `/FastSolicitation/Attendant/New`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: solicitation_
        });
    }

    async reopenSolicitation(data: ReopenSolicitation) {
        const url = this.endpoint + `/FastSolicitation/ReopenNew`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            data
        });

        //return this.api.post(url, data);
    }

    async endSolicitation(solicitation: EndSolicitation) {
        const solicitation_ = JSON.stringify(solicitation);
        const url = this.endpoint + `/FastSolicitation/End`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: solicitation_
        });
    }

    async NewFastWorkAndSLABySolicitationId(idSolicitation: number) {
        const url = `${this.endpoint}/FastSolicitation/NewFastWorkAndSLABySolicitationId/${idSolicitation}`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
        });
    }
}